



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import CoreAPI from "@/utils/core-api";
import EventBus from "@/utils/event-bus";
import { VENTILATOR, FOCUS_SEARCHBAR, bellavistaRegex, pb840Regex, CLEAR_ASSOCIATION_MESSAGE } from "@/utils/constants";
import { Device, PatientDetails, ScanResponseType } from "@/models";
import * as modals from "@/utils/modals";
import { getPatientFullName } from "@/filters/patientName";

@Component
export default class Devices extends Vue {
  @Prop() readonly device!: Device;
  @Prop() readonly patient!: PatientDetails;
  @Prop() readonly scanFirst!: ScanResponseType;

  scanResponseType = ScanResponseType;

  get canDisassociate() {
    return this.patient && this.scanFirst === ScanResponseType.PATIENT;
  }

  get type() {
    if (this.device.type === VENTILATOR) {
      if (this.device.serial.charAt(2) === "V") {
        return "AVEA®";
      } else if (this.device.serial.charAt(2) === "T") {
        return "VELA®";
      } else if (bellavistaRegex.test(this.device.serial)) {
        return "Bellavista™";
      } else if (pb840Regex.test(this.device.serial)) {
        return "PB840";
      }
    }
    return "";
  }

  get ventNameOrSerial() {
    return this.device.name ? this.device.name : this.device.serial;
  }

  async disassociate() {
    EventBus.$emit(CLEAR_ASSOCIATION_MESSAGE);

    try {
      const proceed = await modals.showRemoveAssociationModal(
        this.$bvModal,
        "Remove Ventilator",
        `ventilator ${this.device.name || this.device.serial}`,
        getPatientFullName(this.patient)
      );

      // If the user canceled, nothing to do
      if (!proceed) return;

      try {
        await CoreAPI.associateDevice(this.device.serial, null);
        this.$emit("remove-device");
      } catch (error) {
        if ((error as any).isNetworkError) {
          await modals.showLostConnectionModal(this.$bvModal);
        } else {
          console.error("Failed disassociating", error);
          await modals.showUnexpectedErrorModal(this.$bvModal);
        }
      }
    } finally {
      EventBus.$emit(FOCUS_SEARCHBAR);
    }
  }
}
